<template>
  <div>
    <a-alert
      type="info"
      show-icon
      style="margin-bottom:16px"
      message="配置 App「领券中心」：右上角问号说明文案、顶部红色背景图。上方「国内版 / 国际版」切换后分别保存。"
    />
    <a-spin :spinning="loading">
      <a-form-model :label-col="{span:3}" :wrapper-col="{span:16}" style="max-width:860px">
        <a-form-model-item label="当前分区">
          <a-tag :color="regionKey==='international'?'purple':'blue'">{{ regionLabel }}</a-tag>
        </a-form-model-item>
        <a-form-model-item label="顶部背景图" required>
          <file-upload :value="form.thumb" type="image" :count="1" @change="v => form.thumb = uploadValue(v)" />
          <div class="hint">建议约 750×400px，国内版 / 国际版请分别上传。客户端广告位 type=29。</div>
        </a-form-model-item>
        <a-form-model-item label="优惠券说明">
          <editor
            v-model="form.content"
            :height="360"
            :image-size="5"
            placeholder="点领券中心右上角问号后展示的说明，可排版并插入图片"
          />
          <div class="hint">对应客户端「优惠券说明」弹窗（column_id=11）。请用富文本编辑，勿直接粘贴裸 HTML。</div>
        </a-form-model-item>
        <a-form-model-item label="顶部图状态">
          <a-radio-group v-model="form.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">停用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{span:16,offset:3}">
          <a-button v-hasPermi="['dkmall:coupon:edit']" type="primary" :loading="saving" @click="save">
            保存{{ regionLabel }}配置
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </div>
</template>

<script>
import FileUpload from '@/components/FileUpload'
import Editor from '@/components/Editor'
import { getCouponCenter, saveCouponCenter } from '@/api/dkmall/coupon'

export default {
  name: 'CouponCenterPanel',
  components: { FileUpload, Editor },
  props: {
    region: { type: [Number, String], default: 1 }
  },
  data() {
    return {
      loading: false,
      saving: false,
      form: { thumb: '', content: '', status: 1 }
    }
  },
  computed: {
    regionKey() {
      return Number(this.region) === 2 ? 'international' : 'domestic'
    },
    regionLabel() {
      return this.regionKey === 'international' ? '国际版' : '国内版'
    }
  },
  watch: {
    region: {
      immediate: true,
      handler() { this.load() }
    }
  },
  methods: {
    uploadValue(v) {
      if (typeof v === 'string') return v
      return (v && (v.path || v.url)) || ''
    },
    load() {
      this.loading = true
      getCouponCenter(this.regionKey)
        .then(r => {
          const d = r.data || {}
          this.form = {
            thumb: d.thumb || '',
            content: d.content || '',
            status: d.status == null ? 1 : Number(d.status)
          }
        })
        .catch(() => this.$message.error('领券中心配置加载失败'))
        .finally(() => { this.loading = false })
    },
    save() {
      if (!this.form.thumb) return this.$message.warning('请上传顶部背景图')
      this.saving = true
      saveCouponCenter(this.regionKey, {
        thumb: this.form.thumb,
        content: this.form.content || '',
        status: Number(this.form.status) === 0 ? 0 : 1
      })
        .then(() => this.$message.success(this.regionLabel + '领券中心配置已保存'))
        .catch(e => this.$message.error((e && e.message) || '保存失败'))
        .finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.hint { color: #888; margin-top: 8px; font-size: 12px; }
</style>
